import { type PropsWithChildren, useMemo } from "react";

import { ReadOnlyWorkoutItemWorkoutSetProvider } from "src/components/ReadOnlyWorkoutItemWorkoutSetProvider";
import { LogBodyCell } from "src/components/WorkoutSetLogBodyCell";
import { LogHeadCell } from "src/components/WorkoutSetLogHeadCell";
import {
  type WorkoutItemSetsContextValue,
  workoutSetsWorkoutItemSetsContext,
} from "src/workouts/WorkoutItemSetContext.shared";
import {
  type WorkoutPermissionContextValue,
  workoutPermissionsContext,
} from "src/workouts/WorkoutItemsPermission";

export function ReadOnlyWorkoutSetsWorkoutItemSetsProvider(
  props: PropsWithChildren,
) {
  const value = useMemo<WorkoutItemSetsContextValue>(() => {
    return {
      Provider: ReadOnlyWorkoutItemWorkoutSetProvider,
      getLogCells: () => {
        return [LogHeadCell, LogBodyCell];
      },
    };
  }, []);

  const permissionsValue = useMemo<WorkoutPermissionContextValue>(() => {
    return {
      dragAndDropEnabled: false,
      canEditItems: false,
      canEditSets: false,
      canLogSets: false,
      canEditWorkout: false,
      workoutItemSetShown: true,
      canAddComments: true,
      canAddRootItems: false,
      canImportFromLibrary: false,
      canEditAttributes: false,
    };
  }, []);

  return (
    <workoutPermissionsContext.Provider value={permissionsValue}>
      <workoutSetsWorkoutItemSetsContext.Provider value={value}>
        {props.children}
      </workoutSetsWorkoutItemSetsContext.Provider>
    </workoutPermissionsContext.Provider>
  );
}
